import { Injectable } from '@angular/core';
import {
  FilterCondition,
  FilterDTO,
  FilterOperator,
  PagedResultDTOOfParkerCompanyDTO,
  PagedResultDTOOfParkerDTO,
  PagedResultDTOOfTagsPerParkerReportDTO,
  ParkerClient,
  ParkerCompanyClient,
  SavedReportFileDTO,
  SortDirection,
  TagsPerParkerReportClient,
  TagsPerParkerReportParameterDTO,
} from '../../../../base/models/models.swagger.generated';
import { Observable, throwError } from 'rxjs';
import { ClientService } from '../../../../base/services/client/client.service';
import { catchError } from 'rxjs/operators';
import { ErrorType } from '../../../../core/routing/error-types';
import { ToastService } from '../../../../base/services/toast.service';
import { SaveOptions } from '../../reports-footer/save-options';
import { ShowInactiveService } from '../../../../base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from '../../../../base/shared/syncfusion/adaptor-service.interface';

@Injectable()
export class TagsPerParkerReportService extends ShowInactiveService implements IAdaptorService {

  public filters: FilterDTO[] = [];

  constructor(private tagsPerParkerReportClient: TagsPerParkerReportClient,
              private clientService: ClientService,
              private parkerClient: ParkerClient,
              private parkerCompanyClient: ParkerCompanyClient,
              private toastService: ToastService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfTagsPerParkerReportDTO> {
    if (!filters) {
      filters = [];
    }
    filters = [...filters, ...this.filters];
    if (!sortBy) {
      sortBy = 'Id';
    }
    if (!sortDirection) {
      sortDirection = SortDirection.Descending;
    }
    return this.tagsPerParkerReportClient.searchTagsPerParkerReportData(this.clientService.selectedClient.id, filters, skip, take, sortBy, sortDirection, true)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public exportReport(tagsPerParkerReportParameterDTO: TagsPerParkerReportParameterDTO, saveOptions: SaveOptions): Observable<SavedReportFileDTO> {
    return this.tagsPerParkerReportClient.exportTagsPerParkerReport(
      this.clientService.selectedClient.id,
      saveOptions.exportType,
      saveOptions.saveReport,
      tagsPerParkerReportParameterDTO,
    )
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public searchParkerDropdownValues(searchText: string, selectedCompanyId: string): Observable<PagedResultDTOOfParkerDTO> {
    const filterDTOs = [];
    filterDTOs.push(new FilterDTO({
      isComplex: true,
      condition: FilterCondition.Or,
      predicates: [
        new FilterDTO({
          isComplex: false,
          field: 'FirstName',
          operator: FilterOperator.Contains,
          value: searchText,
        }),
        new FilterDTO({
          isComplex: false,
          field: 'LastName',
          operator: FilterOperator.Contains,
          value: searchText,
        }),
      ],
    }));
    if (selectedCompanyId) {
      filterDTOs.push(new FilterDTO({
        isComplex: false,
        field: 'Company.Id',
        operator: FilterOperator.Equal,
        value: selectedCompanyId,
      }));
    }

    return this.parkerClient.searchParkers(this.clientService.selectedClient.id, filterDTOs, 0, 9, 'Firstname', SortDirection.Ascending, false)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public searchCompanyDropdownValues(searchText: string): Observable<PagedResultDTOOfParkerCompanyDTO> {
    const filterDTOs = [];
    filterDTOs.push(new FilterDTO({
      isComplex: false,
      field: 'Name',
      operator: FilterOperator.Contains,
      value: searchText,
    }));
    return this.parkerCompanyClient.searchParkerCompanies(this.clientService.selectedClient.id, filterDTOs, 0, 9, 'Name', SortDirection.Ascending)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }
}
